module.exports = __webpack_public_path__ + "img/1F1F8-1F1F0.c0c705cf.svg";